module.exports = __webpack_public_path__ + "img/13.d1da78c9.png";